<template>
  <div class="newsDetails publick">
    <div class="article fl">
      <div class="h5">{{info.title}}</div>
      <div class="num">
        <span class="fl look">
          <img src="../list/look.png" width="18" height="18" alt="">
          {{info.read_num}}
        </span>
        <span class="time fr">{{info.create_time}}</span>
      </div>
      <div class="p" v-html="info.content"></div>
    </div>
    <div class="consulting fr">
      <consulting :spnews="spnews"></consulting>
    </div>

    <div style="clear: both;"></div>
    <div class="publick" style="height: 100px;"></div>
  </div>
</template>

<script>
  import consulting from '@/components/news/consulting/consulting'

  export default {
    components: {
      consulting
    },
    data () {
      return {
        spnews: {},
        id: '',
        info: {}
      }
    },
    created () {
      this.id = this.$route.query.id
      this.$store.state.headindex = 99
      this.getSpnews()
      this.getData()
    },
    methods: {
      getSpnews () {
        this.$http.post('/apipx/News/spnews', {
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.spnews = res.data
          }
        })
      },
      getData () {
        this.$http.post('/apipx/News/info', {
          news_id: this.id,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res.data
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .newsDetails {
    margin: 100px auto 0;

    .article {
      width: 700px;
      padding: 35px;
      box-shadow: 0px 0px 20px #f6f6f6;
      overflow: hidden;
      background-color: #fff;
      border-radius: 10px;

      .h5 {
        font-size: 26px;
        width: 700px;
        overflow: hidden;
      }

      .num {
        margin-top: 35px;
        width: 700px;
        overflow: hidden;
        font-size: 14px;
        color: #b3b3b3;
        height: 25px;

        .look {
          width: 560px;
          height: 25px;
          line-height: 25px;
          overflow: hidden;
          font-size: 14px;
          color: #b3b3b3;
          display: block;

          img {
            width: 18px;
            height: 18px;
            display: block;
            float: left;
            margin: 2.5px 10px 0 0;
          }
        }
      }

      .p {
        margin-top: 35px;
        line-height: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/news/details/details.vue